/*
 * @Author: liuxw@codoon.com 
 * @Date: 2020-07-06 14:21:21 
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2020-07-06 14:26:39
 * @Content: 
 */

import { useState, useEffect, useCallback } from 'react';

/**
 * 打开Toast提示
 */
export const useShowToast = () => {
    const [toastVisible, setToastVisible] = useState<boolean>(false);
    const [toastTip, setToastTip] = useState<string>("");

    const showToast = useCallback((tip: string) => {
        setToastVisible(true);
        setToastTip(tip);
        setTimeout(() => {
          setToastVisible(false);
          setToastTip("");
        }, 2000);
      }, []);

    return {
        toastVisible,
        toastTip,
        showToast
    };
}